import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const HeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: "26px",
      fontWeight: theme.typography.fontWeightBold,
    },
    currency: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.disabled,
    },
    iconCurrencyContainer: {
      // alignItems: "center",
      height: "100%",
      textAlign: "center",
    },
    icon: {
      marginTop: "5px",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
  }),
);
